import _slicedToArray from "C:/Users/Marie/Desktop/2022/april/meh/my-gatsby-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function e(e) {
  var _$exec$slice = /schema\/([\w-]+)\/([\w\.\-]+)\.json$/g.exec(e).slice(1, 3),
      _$exec$slice2 = _slicedToArray(_$exec$slice, 2),
      n = _$exec$slice2[0],
      r = _$exec$slice2[1];

  return {
    library: n,
    version: r
  };
}

export default e;